export default "__VITE_ASSET__yky2e4Ul__"